export const profileConstants = {
  SET_STATE_PROFILE: "SET_STATE_PROFILE",
  SET_LANDING_PAGE: "SET_LANDING_PAGE",
  INITIAL_PAGE_LOAD: "INITIAL_PAGE_LOAD",
  HISTORY: "HISTORY"
};

export const profileLandingPages = {
  LANDING_PAGE_HOME: "/",
  LANDING_PAGE_PROFILE_NEWS: "profile/news",
  LANDING_PAGE_PROFILE_COURTS: "profile/courts",
  LANDING_PAGE_PROFILE_TEAM: "profile/team",
  LANDING_PAGE_PROFILE_WORK: "profile/work",
  LANDING_PAGE_PROFILE_BENEFIT: "profile/benefit"
};
